import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import './Modal.css';

import { Flex, Box } from 'grid-styled';

import ModalSelect from './ModalSelect';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

import Background from '../assets/alert-circle.png';

class StreamInputModal extends Component {
    componentDidMount() {
        // this.props.validateModel();
    }

    validateModel = () => {
        const { model } = this.props;

        let validationVariable = model.validateModelByModal('input');

        let validationObject = {};

        if (validationVariable.length > 0) {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: false
            });
        } else {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: true
            });
        }
    };

    genSamplingValue = () => {
        // STEREO INPUT
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'aac'
        )
            return ['32000', '44100', '48000'];
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'mp3'
        )
            return ['44100', '48000'];
        // MONO Input
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'aac'
        )
            return ['22050', '32000', '44100', '48000'];
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'mp3'
        )
            return ['22050', '24000', '44100', '48000'];

        return ['8000', '12000', '16000', '24000', '32000', '44100', '48000'];
    };
    genSamplingLabels = () => {
        // STEREO INPUT
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'aac'
        )
            return ['32 kHz', '44.1 kHz', '48 kHz'];
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'mp3'
        )
            return ['44.1 kHz', '48 kHz'];
        // MONO Input
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'aac'
        )
            return ['22.05 kHz', '32 kHz', '44.1 kHz', '48 kHz'];
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'mp3'
        )
            return ['22.05 kHz', '24 kHz', '44.1 kHz', '48 kHz'];

        return [
            '8 kHz',
            '12 kHz',
            '16 kHz',
            '24 kHz',
            '32 kHz',
            '44.1 kHz',
            '48 kHz'
        ];
    };

    render() {
        const { model, updateState, statevariable } = this.props;

        return (
            <Box>
                <Flex>
                    <Box w={2 / 3}>
                        <ModalSelect
                            label="Input Source"
                            model={model}
                            optionsValue={['line-in']}
                            optionsName={['Line-IN']}
                            name="inputsource"
                            validateModel={this.props.validateModel}
                            updateState={updateState}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.inputsource}
                            background={Background}
                            tiptext="Choose the desired input source. Line-IN corresponds to the input provided by the RCA / Cinch connector."
                        />
                        <ModalSelect
                            label="Input Level"
                            model={model}
                            optionsValue={['nominal', 'consumer']}
                            optionsName={[
                                'Nominal (0 dBu)',
                                'Consumer (-10 dBu)'
                            ]}
                            name="inputlevel"
                            validateModel={this.props.validateModel}
                            updateState={updateState}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.inputlevel}
                            background={Background}
                        />
                        <ModalSelect
                            label="Input Channel"
                            model={model}
                            optionsValue={['mono-left', 'mono-right', 'stereo']}
                            optionsName={['Mono Left', 'Mono Right', 'Stereo']}
                            name="inputchannel"
                            updateState={updateState}
                            validateModel={this.props.validateModel}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.inputchannel}
                            background={Background}
                            tiptext="This corresponds to the what data you want to capture from your RCA / Cinch connector. Select Mono-Left for the white cable, Mono-Right for the red cable, Stereo for their combination."
                        />
                        <ModalSelect
                            label="Sampling Rate"
                            model={model}
                            name="samplingrate"
                            updateState={updateState}
                            validateModel={this.props.validateModel}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.samplingrate}
                            background={Background}
                            optionsValue={this.genSamplingValue(model)}
                            optionsName={this.genSamplingLabels(model)}
                            tiptext="Influences the quality of the captured data. A high sampling rate means more information, i.e. more precise data but a bigger volume."
                        />
                    </Box>
                    <BoxTemplate
                        textalign="left"
                        mr={'15px'}
                        ml={'15px'}
                        w={1 / 3}
                    >
                        <Label textStyle="labelSmall">
                            <b>AUDIO SETTINGS</b>
                            <br />
                            These settings define the audio parameters.
                            <br />
                            <b>Input source</b>
                            <br />
                            Choose the desired input source. Line-IN corresponds
                            to the input provided by the RCA / Cinch connector.
                            <br />
                            <b>Input level</b>
                            <br />
                            Select the input/operating level that best suits
                            your input device. The idea here is to optimize the
                            dynamic range, i.e. prevent clipping, for instance.
                            <br />
                            <b>Input channel</b>
                            <br />
                            This corresponds to how you want to capture from
                            your RCA / Cinch connector. Select Mono-Left for the
                            white cable, Mono-Right for the red cable, Stereo
                            for their combination.
                            <br />
                            <b>Sampling rate</b>
                            <br />
                            Select your desired sampling frequency, a higher
                            sampling frequency means more information, i.e. more
                            precise data but requires a higher bandwidth.
                        </Label>
                    </BoxTemplate>
                </Flex>
            </Box>
        );
    }
}

export default inject('model')(observer(StreamInputModal));



// WEBPACK FOOTER //
// ./src/form/StreamInputModal.js